import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import cx from 'classnames';
import { Tooltip, TooltipContent, TooltipTrigger } from '../TooltipV2/TooltipV2';
import EllipsisText from '../EllipsisText';
import { DateFormat, dateFormat } from '@cp/src/utils/DateHelper';
import styles from './index.module.scss';
import { ITimeAgo } from './types';

const ONE_MIN_TIME_INTERVAL = 60000;
const ONE_HOUR_TIME_INTERVAL = 3600000;

const TimeAgo = (props: ITimeAgo) => {
  const {
    epoch,
    ellipsisClass,
    tooltipPlacement = 'bottom',
    hideTooltipWhenDiffIsOneDay = false
  } = props;
  const [currentTime, setCurrentTime] = useState('');
  const [pollingInterval, setPollingInterval] = useState(ONE_MIN_TIME_INTERVAL); // Default polling interval

  const updateTime = () => {
    const now = dayjs();
    const time = dayjs(epoch);
    const diffInMinutes = now.diff(time, 'minute');

    if (diffInMinutes < 60) {
      setPollingInterval(ONE_MIN_TIME_INTERVAL); // Poll every minute
    } else if (diffInMinutes >= 60 && diffInMinutes < 1440) {
      setPollingInterval(ONE_HOUR_TIME_INTERVAL); // Poll every hour
    } else {
      setPollingInterval(0); // Do not poll for a day or more
    }

    if (now.diff(time, 'day') >= 1) {
      setCurrentTime(dateFormat(new Date(epoch), DateFormat.LONG_DATE_FORMAT_WITH_TIME));
    } else {
      setCurrentTime(time.fromNow());
    }
  };

  useEffect(() => {
    updateTime();
    if (pollingInterval) {
      const intervalId = setInterval(() => {
        updateTime();
      }, pollingInterval);

      return () => clearInterval(intervalId);
    }
  }, [pollingInterval]);

  return (
    <Tooltip placement={tooltipPlacement} hiddenPadding={10} hideStrategy="referenceHidden">
      <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
        <EllipsisText
          text={epoch ? currentTime : '-'}
          lineClamp={1}
          ellipsisWrapperClass={cx(styles.ellipsisWrapperClass, ellipsisClass)}
        />
      </TooltipTrigger>
      {!(pollingInterval === 0 && hideTooltipWhenDiffIsOneDay) ? (
        <TooltipContent className="tooltipWrapper">
          {dateFormat(new Date(epoch), DateFormat.LONG_DATE_FORMAT_WITH_TIME)}
        </TooltipContent>
      ) : null}
    </Tooltip>
  );
};

export default TimeAgo;
